import React from 'react';
import './styles/Logo.css'; // Create this CSS file for styling
import Logo from "../assets/logo.gif";

const LogoScreen = () => {
  return (
    <div id="logo-screen">
      <img src={Logo} alt="Logo" id="logo" />
    </div>
  );
};

export default LogoScreen;